import ReactDOM from "react-dom/client";
import { useLayoutEffect } from "react";
// import "./locals/index";
import { initI18n } from "./locals/index";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { SnackbarProvider } from "notistack";
import { SnackbarUtilsConfigurator } from "./components/NotistackPlus";
import { QueryClientProvider, QueryClient } from "@tanstack/react-query";
import { LicenseInfo } from "@mui/x-license-pro";
import { useConfigStore } from "./store/config";
import { useUrfReceiveEvents } from "./hooks/urfEvents";
import "./assets/scss/index.scss";


// console.log("MUI_LICENSE_KEY: ", process.env.REACT_APP_MUI_LICENSE_KEY)
LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_LICENSE_KEY as string);

const queryClient = new QueryClient();

const LanguageGate = () => {
  useUrfReceiveEvents();
  const language = useConfigStore((state) => state.language);

  useLayoutEffect(() => {
    void initI18n(language);
  }, [language]);

  return (
    <SnackbarProvider
      maxSnack={2}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
    >
      <SnackbarUtilsConfigurator />
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </SnackbarProvider>
  );
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

async function bootstrap() {
  // Local MSW mock disabled for backend integration debugging.
  // if (process.env.NODE_ENV === "development") {
  //   const { worker } = await import("./mocks/browser");
  //   await worker.start({ onUnhandledRequest: "bypass" });
  // }
  root.render(<LanguageGate />);
}

void bootstrap();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
